/* src/app/modules/shared/components/calculator/calculator.component.scss */
.calculator {
  margin-left: 0;
}
.output {
  text-align: left;
}
/*# sourceMappingURL=calculator.component.css.map */
